// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GamesNav_wrapper__r6bMg","title":"GamesNav_title__3yx6H","list":"GamesNav_list__2dVgO"};